import React, { useContext, useState } from "react";
import { PageContext } from "./Pages.js";
import "../styles/CouponsPage.scss";

const rows = [
  {
    key: "c1",
    logo: "/images/Manning.png",
    alt: "Manning",
    link: "https://bit.ly/4bo17ER",
  },
  {
    key: "c2",
    logo: "/images/PNS.png",
    alt: "PNS",
    link: "https://bit.ly/3NlrnX8",
  },

  {
    key: "c3",
    logo: "/images/Watson.png",
    alt: "Watson",
    link: "https://bit.ly/4bgOSK0",
  },
  {
    key: "c4",
    logo: "/images/Wellcome.png",
    alt: "Wellcome",
    link: "https://bit.ly/4lDq5DG",
  },
  {
    key: "c5",
    logo: "/images/HKTVmall.png",
    alt: "HKTVmall",
    link: "https://bit.ly/4bhNKWC",
  },
];

const CouponsPage = () => {
  const { setCurrentStep } = useContext(PageContext);
  const [showTncPopup, setShowTncPopup] = useState(false);
  // const [copiedMessage, setCopiedMessage] = useState("");

  const handleCopyCode = (code) => {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard
        .writeText(code)
        .then(() => {
          alert(`已成功複製優惠碼：${code}`);
        })
        .catch(() => {
          fallbackCopyText(code);
        });
    } else {
      fallbackCopyText(code);
    }
  };

  const fallbackCopyText = (code) => {
    try {
      const textArea = document.createElement("textarea");
      textArea.value = code;
      textArea.setAttribute("readonly", "");
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";
      textArea.style.left = "-9999px";
      document.body.appendChild(textArea);

      textArea.focus();
      textArea.select();
      textArea.setSelectionRange(0, textArea.value.length);

      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);

      if (successful) {
        alert(`已成功複製優惠碼：${code}`);
      } else {
        alert(`請手動複製優惠碼：${code}`);
      }
    } catch (e) {
      alert(`請手動複製優惠碼：${code}`);
    }
  };
  return (
    <div className="coupons-page-container">
      {/* 背景 */}
      <img
        className="background-image"
        src="./images/coupons_page_background.jpg"
        alt="background"
      />
      <div className="coupons-8-button-container">
        <img
          className="coupons-button"
          src="./images/code_2col.png"
          onClick={() => handleCopyCode("CAFE2COL")}
          alt="back"
        />
      </div>
      <div className="coupons-15-button-container">
        <img
          className="coupons-button"
          src="./images/code_1col.png"
          onClick={() => handleCopyCode("CAFE1COL")}
          alt="back"
        />
      </div>

      {/* 返回按鈕 */}
      {/* <div className="back-button-container">
        <img
          className="back-button"
          src="./images/back_to_home_page_button.png"
          onClick={() => setCurrentStep(0)}
          alt="back"
        />
      </div> */}

      {/* 🔥 新加：Logo + Link list */}
      <div className="content-overlay">
        {rows.map((r) => (
          <div key={r.key} className="logo-button-row">
            {/* 左邊 logo */}
            <div className="logo-slot">
              <img src={r.logo} alt={r.alt} className="logo" />
            </div>

            {/* 右邊 button */}
            <a
              href={r.link}
              target="_blank"
              rel="noreferrer"
              className="button-link"
            >
              <img
                src="/images/buy_link.png"
                alt="link"
                className="button-img"
              />
            </a>
          </div>
        ))}
      </div>
      <div className="coupons-tnc-text">
        <sup>*</sup>優惠受
        <span className="tnc-link" onClick={() => setShowTncPopup(true)}>
          條款及細則約束
        </span>
        。
      </div>
      {showTncPopup && (
        <div className="tnc-overlay" onClick={() => setShowTncPopup(false)}>
          <div className="tnc-popup" onClick={(e) => e.stopPropagation()}>
            <div className="tnc-popup-inner">
              <div
                className="tnc-close-button"
                onClick={() => setShowTncPopup(false)}
              >
                x
              </div>
              <div className="tnc-title">高露潔＄8現金券條款及細則</div>
              <div className="tnc-content">
                <ul>
                  <li>此現金券有效日期由2026年4月3日至2026年12月31日。</li>

                  <li>
                    此現金券只適用於有效日期內，於指定商戶憑券購買任何一件高露潔光感•白白金迅白美白牙膏或光感•白白金持久美自牙膏，可作$8使用。
                  </li>
                  <li>
                    此現金券只適用於香港地區的萬寧門市及網店、百佳超級市場、FUSION、TASTE、TASTE
                    X FRESH新鮮生活、INTERNATIONAL、FOOD PARC、GREAT FOOD
                    HALL、PNS網購、屈臣氏門市及網店、惠康超級市場門市及網店，Market
                    Place、3hreesixty、Oliver's The Delicatessen、HKTVmall。
                  </li>
                  <li>
                    請於網店結帳前輸入優惠碼「CAFE2COL」（萬寧門市及網店、百佳超級市場、FUSION、TASTE、TASTE
                    X FRESH新鮮生活、INTERNATIONAL、FOOD PARC、GREAT FOOD
                    HALL、PNS網購、屈臣氏門市及網店、惠康超級市場門市及網店，Market
                    Place、3hreesixty、Oliver's The
                    Delicatessen、HKTVmall）或「cafe2col」（HKTVmall），或於門市使款前出示此現金券方可享優惠，恕不接受列印本。
                  </li>
                  <li>部分貨品只限於指定店鋪提供，貨品數最有限，售完為止。</li>
                  <li>此現金券只可使用一次，每次一張，使用後將被收回。</li>
                  <li>每個訂單只能使用一個優惠碼。</li>
                  <li>每個帳戶只可享用此優惠碼一次。</li>
                  <li>優惠碼數量有限，用完即止。</li>
                  <li>
                    此現金券不適用於出位價/試用裝/換購價產品及不可與其他優惠同時使用。
                  </li>
                  <li>
                    此現金券如有更改、損毀或偽造則予作廢，香港高露潔棕櫃有限公司將對前述行為依法行使法律權利。
                  </li>
                  <li>此現金券不可兌換現金或其他貨品，並不設找贖。</li>
                  <li>
                    若欲辦理退貨，將根據各店舖之換貨程序處理，不得退回現金或現金券，
                  </li>
                  <li>
                    如有任何爭議，香港高露潔棕撤有限公司及指定商戶將保留最終決定權，
                  </li>
                  <li>
                    如有任何現金券使用問題，歡迎消費者聯絡者港高露潔棕櫃有限公司香港消費者免費諮詢熱線：800-938281，服務時間為週一至週五上午十點至下午五點。
                  </li>
                  <li>
                    香港高露潔棕櫃有限公司保留隨時修改、終止，取消以上活動之權利，毋須事先通知。
                  </li>
                  <li>如有任何爭議，香港高露潔棕欖有限公司保留最終決定權。</li>
                </ul>
              </div>
              <div className="tnc-title">高露潔＄15現金券條款及細則</div>
              <div className="tnc-content">
                <ul>
                  <li>此現金券有效日期由2026年4月3日至2026年12月31日。</li>
                  <li>
                    此現金券只適用於有效日期內，於指定商戶憑券購買任何一件高露潔光感•白閃耀亮白牙膏或光感•白臻極亮白牙膏，可享有$15優惠。
                  </li>
                  <li>
                    此現金券只適用於香港地區的萬寧門市及網店、百佳超級市場、FUSION、TASTE、TASTE
                    X FRESH新鮮生活、INTERNATIONAL、FOOD PARC、GREAT FOOD
                    HALL、PNS網購、屈臣氏門市及網店、惠康超級市場門市及網店，Market
                    Place、3hreesixty、Oliver's The Delicatessen、HKTVmall。
                  </li>
                  <li>
                    請於網店結帳前輸入優惠碼「CAFE1COL」，或於門市付款前出示此現金券方可享優惠
                  </li>
                  <li>部分貨品只限於指定店鋪提供，貨品數最有限，售完為止。</li>
                  <li>此現金券只可使用一次，每次一張，使用後將被收回。</li>
                  <li>每個訂單只能使用一個優惠碼。</li>
                  <li>每個帳戶只可享用此優惠碼一次。</li>
                  <li>優惠碼數量有限，用完即止。</li>
                  <li>
                    此現金券不適用於出位價/試用裝/換購價產品及不可與其他優惠同時使用。
                  </li>
                  <li>
                    此現金券如有更改、損毀或偽造則予作廢，香港高露潔棕櫃有限公司將對前述行為依法行使法律權利。
                  </li>
                  <li>此現金券不可兌換現金或其他貨品，並不設找贖。</li>
                  <li>
                    若欲辦理退貨，將根據各店舖之換貨程序處理，不得退回現金或現金券，
                  </li>
                  <li>
                    如有任何爭議，香港高露潔棕撤有限公司及指定商戶將保留最終決定權，
                  </li>
                  <li>
                    如有任何現金券使用問題，歡迎消費者聯絡者港高露潔棕櫃有限公司香港消費者免費諮詢熱線：800-938281，服務時間為週一至週五上午十點至下午五點。
                  </li>
                  <li>
                    香港高露潔棕櫃有限公司保留隨時修改、終止，取消以上活動之權利，毋須事先通知。
                  </li>
                  <li>如有任何爭議，香港高露潔棕欖有限公司保留最終決定權。</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CouponsPage;
